import { type ComponentProps, forwardRef } from 'react';
import { type ScrollView, StyleSheet, View, type ViewStyle } from 'react-native';

import { Scrollspy, theme, useContainerSpacing, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationIngredientsGridNav = forwardRef<
  ScrollView,
  CustomizationIngredientsGridNavProps
>((props, ref) => {
  const { children, outerContainerStyle, ...restProps } = props;

  const { match } = useResponsive();
  const containerSpacing = useContainerSpacing();

  return (
    <View
      style={[
        styles.container,
        outerContainerStyle,
        match([styles.containerXS, styles.containerSM]),
      ]}
    >
      <Scrollspy.Nav
        ref={ref}
        gap={theme.spacing['4']}
        stagePadding={containerSpacing}
        {...restProps}
      >
        {children}
      </Scrollspy.Nav>
    </View>
  );
});

CustomizationIngredientsGridNav.displayName = 'CustomizationIngredientsGridNav';

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.DARK_KALE,
    backgroundColor: theme.colors.CREAM,
  },
  containerXS: {
    paddingVertical: theme.spacing['4'],
  },
  containerSM: {
    paddingVertical: theme.spacing['6'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type CustomizationIngredientsGridNavProps = ComponentProps<typeof Scrollspy.Nav> & {
  outerContainerStyle?: ViewStyle;
};
